// @ts-check

import { useEffect, useRef, useState } from "react";
import "../jsdoc-types"

/**
 * @param {Object} props
 * @param {PageEntry} props.pageCdaEntry
 */
export const Robert = ({ pageCdaEntry }) => {
	const { iframeRef, iframeHeight } = useResizeIframe();

	// Remove the "/service" prefix and any leading or trailing slashes
	const pageurl = pageCdaEntry.fields.slug
		.replace(/^\/service/, "")
		.replace(/(?:^\/|\/$)/g, "")

	return (
		<section className="service-page-robert">
			<iframe
				ref={iframeRef}
				style={{
					height: `${iframeHeight}px`,
				}}
				src={`/htmlelement/robert_script.htm?pageurl=${pageurl}`}
				title="Frag Robert"
			></iframe>
		</section>
	);
}

/**
 * Automatically resizes the iframe to fit its content
 */
const useResizeIframe = () => {
	const [iframe, setIframe] = useState(null);
	const interval = useRef(null);
	const [height, setHeight] = useState(291);

	useEffect(() => {
		if (iframe) {
			interval.current = setInterval(() => {
				setHeight(iframe.contentWindow.document.body.scrollHeight);
			}, 300);
		}

		return () => {
			clearInterval(interval.current);
		};
	}, [iframe]);

	return { iframeRef: setIframe, iframeHeight: height };
}
